import React from 'react';
import { Popover } from 'kepler';
class Donationprogress extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			propertyInfo:this.props.propertyInfo,
			trackDonationInfo:this.props.trackDonationInfo,
		};
	}
	render() {
		let trackDonationInfo = this.state.trackDonationInfo,
			propertyInfo = this.state.propertyInfo,
			logo_url = (trackDonationInfo.charity_info && trackDonationInfo.charity_info.logo_url) ? trackDonationInfo.charity_info.logo_url : 'https://www.paypalobjects.com/webstatic/ppgf/donationtracker/Placeholder_logo.svg',
			logoBoxStyle = (trackDonationInfo.charity_info && trackDonationInfo.charity_info.logo_url) ?
				{
					"backgroundImage": `url(${logo_url})`,
					"backgroundPosition": "center center",
					"backgroundRepeat": "no-repeat",
					"backgroundSize": "contain"
				} :
				{
					"backgroundImage": `url(${logo_url})`,
					"backgroundPosition": "center center",
					"backgroundRepeat": "no-repeat"
				},
			opacity = (trackDonationInfo.payout_status == 3) ? "opacity" : "",
			delayedPopupContent = (
				<div>{propertyInfo.trackdonation.modalpara1}<br /><br />{propertyInfo.trackdonation.modalpara2}</div>
			),
			unEnrolledPopupContent = (
				<div>{propertyInfo.trackdonation.dpunenrolledtooltip}</div>
			),
			enrolledPopupContent = (
				<div>{propertyInfo.trackdonation.dpenrolledtooltip}</div>
			),
			payoutMode = (trackDonationInfo.payout_mode == "PAYPAL") ? propertyInfo.trackdonation.paidviapaypal : propertyInfo.trackdonation.checkmailtocharity,
			donation_source;
		if (trackDonationInfo.donation_info && trackDonationInfo.donation_info.methodof_donation) {
			let methodof_donation = trackDonationInfo.donation_info.methodof_donation,
				methodof_donation_match_for_GB = methodof_donation.match(/^8/g),
				methodof_donation_match_for_CA = methodof_donation.match(/^2/g),
				methodof_donation_match_for_AU = methodof_donation.match(/^6/g);
			donation_source = (methodof_donation_match_for_GB == 8) ? propertyInfo.trackdonation.charitycommission : (methodof_donation_match_for_CA == 2) ? propertyInfo.trackdonation.careviewagency : (methodof_donation_match_for_AU == 6) ? propertyInfo.trackdonation.acnc : propertyInfo.trackdonation.guidestar;
		}
    	
		return (
			<div id="donateprogress">
				<div className="">
					<div className="charityinfoBox">
						<div className="logoBox" style={logoBoxStyle}>
						</div>
						<div className="charityinfoBoxLeft hidden-xs">
							{trackDonationInfo.charity_info && trackDonationInfo.charity_info.name ?
								<div>
									<h1>{trackDonationInfo.charity_info.name}</h1>
									<p>{trackDonationInfo.charity_info.mission}</p>
								</div> : ''}
							<p>{propertyInfo.trackdonation.source}{(trackDonationInfo.charity_type == "UNENROLLED") ? <span className="unenrolled">{donation_source}</span> : <span className="enrolled">{propertyInfo.trackdonation.ppgfprofile}</span> }</p>
							<p className="Status-With-PayPal"> <span className="text-style">{propertyInfo.trackdonation.status}</span>
							{(trackDonationInfo.payout_status == 3)? <span className="delayed">{propertyInfo.trackdonation.delayeddelivery}<Popover placement="top"  content={delayedPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover></span>:(trackDonationInfo.payout_status == 4)?<span className="completed">{propertyInfo.trackdonation.senttocharity}</span> : <span className="underprocess">{propertyInfo.trackdonation.withppgf}</span> }</p>
						</div>
						<div className="charityinfoBoxRight hidden-xs">
							<p>#{trackDonationInfo.transaction_id}</p>
						</div>
						<div className="charityinfoBoxRight visible-xs">
							<p className="Status-With-PayPal"> <span className="text-style">{propertyInfo.trackdonation.status}</span>
							{(trackDonationInfo.payout_status == 3)? <span className="delayed">{propertyInfo.trackdonation.delayeddelivery}<Popover placement="top"  content={delayedPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover></span>:(trackDonationInfo.payout_status == 4)?<span className="completed">{propertyInfo.trackdonation.senttocharity}</span> : <span className="underprocess">{propertyInfo.trackdonation.withppgf}</span> }</p>
							<p>#{trackDonationInfo.transaction_id}</p>
						</div>
						<div className="charityinfoBoxLeft visible-xs">
							{trackDonationInfo.charity_info && trackDonationInfo.charity_info.name ?
								<div>
									<h1>{trackDonationInfo.charity_info.name}</h1>
									<p>{trackDonationInfo.charity_info.mission}</p>
								</div>
								: ''}
							<p>{propertyInfo.trackdonation.source}{(trackDonationInfo.charity_type == "UNENROLLED") ? <span className="unenrolled">{donation_source}</span> : <span className="enrolled">{propertyInfo.trackdonation.ppgfprofile}</span> }</p>
						</div>
					</div>
					<div className="progressBarWrap hidden-xs">
						<div id="progress" className={opacity}>
						{(trackDonationInfo.payout_status == 1 || trackDonationInfo.payout_status == 2) ? <div className="progress-bar-half"></div> : ""}
						{trackDonationInfo.payout_status == 3 ? <div className="progress-bar-delayed"></div> : ""}
						{trackDonationInfo.payout_status == 4 ? <div className="progress-bar"></div> : ""}
						</div>
					</div>
					<div className="donationStatus hidden-xs">
						<div className="span4 pull-left">
							<h5>{propertyInfo.trackdonation.donationmade}</h5>
							<p>{trackDonationInfo.convertedtransactdate}</p>
						</div>
						<div className="span4 pull-left">
							<h5 className="text-center">{propertyInfo.trackdonation.develiverypending} {trackDonationInfo.charity_type == "UNENROLLED" ? <Popover placement="top"  content={unEnrolledPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover> : <Popover placement="top"  content={enrolledPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover>}</h5>
						</div>
						<div className="span pull-right">
							{trackDonationInfo.payout_status == 4 ? <h5>{payoutMode}</h5> : <h5>{propertyInfo.trackdonation.estimatedpayoutdate}</h5>}
							<p>{trackDonationInfo.convertedpytdate}</p>
						</div>
					</div>
					<div className="donationStatus visible-xs">
						<div className="progressBarWrap">
							<div id="progress" className={opacity}>
								{(trackDonationInfo.payout_status == 1 || trackDonationInfo.payout_status == 2) ? <div className="progress-bar-half"></div> : ""}
								{trackDonationInfo.payout_status == 3 ? <div className="progress-bar-delayed"></div> : ""}
								{trackDonationInfo.payout_status == 4 ? <div className="progress-bar"></div> : ""}
							</div>
							<div className="span4">
								<h5>{propertyInfo.trackdonation.donationmade}</h5>
								<p>{trackDonationInfo.convertedtransactdate}</p>
							</div>
							<div className="span4">
								<h5>{propertyInfo.trackdonation.develiverypending} {trackDonationInfo.charity_type == "UNENROLLED" ? <Popover placement="top"  content={unEnrolledPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover> : <Popover placement="top"  content={enrolledPopupContent}><span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span></Popover>}</h5>
							</div>
							<div className="span4">
								{trackDonationInfo.payout_status == 4 ? <h5>{payoutMode}</h5> : <h5>{propertyInfo.trackdonation.estimatedpayoutdate}</h5>}
								<p>{trackDonationInfo.convertedpytdate}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);

	}
}
export default Donationprogress;


// WEBPACK FOOTER //
// ./trackdonation/components/donationProgress.js